import { useEditorNarrationDurationQuery } from "../../../../graphql/graphqlGeneratedTypes/graphqlClient";
import type { GqlClientAvatarInfo, GqlClientEditorNarrationDurationQuery } from "../../../../graphql/graphqlGeneratedTypes/graphqlClient";

export type UseNarrationDuration = {
    narrationDuration: GqlClientEditorNarrationDurationQuery["editorNarrationDuration"];
    loadingNarrationDuration: boolean;
    refetchNarrationDuration: () => void;
};

export const useNarrationDuration = (
    text: string,
    rate: number,
    service: string,
    narrator: string,
    avatarInfo?: GqlClientAvatarInfo,
    isNarrationEdited: boolean = false,
    skip: boolean = false
): UseNarrationDuration => {
    const { loading: loadingNarrationDuration, data, refetch: refetchNarrationDuration } = useEditorNarrationDurationQuery({
        variables: {
            text,
            rate,
            service,
            narrator,
            avatarInfo
        },
        skip: skip || !text || !service || !narrator,
        fetchPolicy: isNarrationEdited ? "cache-only" : "cache-first"
    });

    const narrationDuration = data?.editorNarrationDuration;

    return { narrationDuration, loadingNarrationDuration, refetchNarrationDuration };
};
